import React, { Component } from "react";
import "./ventas.css";
import SpinnerModal from "../../componentes/spiner/SpinnerModal";
import Navbar from "../../componentes/navbar/navbar";
import { getVntas, importarVentasExcel, importSantanderExcel } from "../../service/api";
import ImportVentasModal from "../../componentes/modal/ImportVentasModal";
import { toast } from "react-toastify";

export default class VentasPage extends Component {
    state = {
        loading: false,
        fecha: this.toISODate(new Date()),
        ventas: [],
        page: 1,
        sortKey: "ticket",
        sortDir: "asc",
        pageSize: 10,
        vermodalImpor: false,
        banderaSubir: "normal",
    };

    componentDidMount() {
        this.setState({ loading: true });

        const datos = localStorage.getItem("datosm");
        if (!datos || datos == "") {
                window.location.href = "/";
                return;
            // this.fetchVentas(this.state.fecha);

        }
        else {
            this.fetchVentas(this.state.fecha);
        }

    }

    toISODate(dateObj) {
        const y = dateObj.getFullYear();
        const m = String(dateObj.getMonth() + 1).padStart(2, "0");
        const d = String(dateObj.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    }

    onChangePageSize = (e) => {
        const pageSize = Number(e.target.value || 10);
        this.setState({ pageSize, page: 1 });
    };

    currencyMX = (n) => {
        const val = Number(n || 0);
        return val.toLocaleString("es-MX", { style: "currency", currency: "MXN" });
    };


    normalizeVenta = (v, fechaISO) => {
        const metodo = v?.metodo_pago ?? "";
        const digitos = v?.ultimos_digitos ? ` •••• ${v.ultimos_digitos}` : "";
        const metodoPago = `${metodo}${digitos}`.trim();

        const detalles = {
            subtotal: v?.subtotal ?? 0,
            iva: v?.iva ?? 0,
        };

        return {
            ticket: v?.idticket ?? v?.idticketpago ?? "-",
            locacion: v?.locacion ?? "-",
            metodoPago: metodoPago || "-",
            detalles,
            total: v?.total ?? 0,
            propina: v?.propina ?? 0,
            fecha: `${fechaISO}${v?.hora ? ` ${v.hora}` : ""}`,
            numeroProductos: v?.productos ?? 0,
            estatus: v?.estatus ?? "-",
            ticketPdfUrl: null,
            facturaPdfUrl: null,
            _key: `${v?.idticketpago ?? "x"}-${v?.idticket ?? "y"}`,
        };
    };


    fetchVentas = async (fechaISO) => {
        this.setState({ loading: true });

        try {
            const json = { fecha: fechaISO };
            const resp = await getVntas(json);

            if (resp.code == 0) {

                const raw = resp?.data || [];
                const arr = Array.isArray(raw) ? raw : raw?.data || [];
                const ventas = (arr || []).map((v) => this.normalizeVenta(v, fechaISO));
                this.setState({ ventas, page: 1 });
                this.setState({ loading: false });

            }
            else {
                this.setState({ loading: false });
                toast.info(resp.message);
            }

        } catch (e) {

            this.setState({ loading: false });
            this.setState({ ventas: [], page: 1 });

        } finally {
            this.setState({ loading: false });
        }
    };

    onChangeFecha = (e) => {
        const fecha = e.target.value;
        this.setState({ fecha }, () => this.fetchVentas(fecha));
    };

    onImportar = (bandera) => {
        this.setState({ banderaSubir: bandera, vermodalImpor: true });

    };


    compareValues = (a, b) => {
        if (a == null) a = "";
        if (b == null) b = "";

        const na = Number(a);
        const nb = Number(b);

        const bothNumeric = !Number.isNaN(na) && !Number.isNaN(nb) && String(a).trim() !== "" && String(b).trim() !== "";
        if (bothNumeric) return na - nb;

        return String(a).localeCompare(String(b), "es", { numeric: true, sensitivity: "base" });
    };

    getSortValue = (v, key) => {
        switch (key) {
            case "ticket":
                return v.ticket;
            case "locacion":
                return v.locacion;
            case "metodoPago":
                return v.metodoPago;
            case "subtotal":
                return v.detalles?.subtotal;
            case "iva":
                return v.detalles?.iva;
            case "total":
                return v.total;
            case "propina":
                return v.propina;
            case "fecha":
                return v.fecha;
            case "numeroProductos":
                return v.numeroProductos;
            case "estatus":
                return v.estatus;
            default:
                return "";
        }
    };

    onSort = (key) => {
        this.setState((prev) => {
            const same = prev.sortKey === key;
            const nextDir = same && prev.sortDir === "asc" ? "desc" : "asc";
            return { sortKey: key, sortDir: nextDir };
        });
    };



    // ===== PAGINACIÓN =====
    totalPages = () => {
        const { ventas, pageSize } = this.state;
        return Math.max(1, Math.ceil((ventas?.length || 0) / pageSize));
    };

    setPage = (p) => {
        const tp = this.totalPages();
        const next = Math.min(tp, Math.max(1, p));
        this.setState({ page: next });
    };

    getPageItems = () => {
        const { ventas, page, pageSize, sortKey, sortDir } = this.state;

        const sorted = [...ventas].sort((va, vb) => {
            const a = this.getSortValue(va, sortKey);
            const b = this.getSortValue(vb, sortKey);
            const cmp = this.compareValues(a, b);
            return sortDir === "asc" ? cmp : -cmp;
        });

        const safePage = this.ensureValidPage(page, sorted.length, pageSize);
        if (safePage !== page) {
            setTimeout(() => this.setState({ page: safePage }), 0);
        }

        const start = (safePage - 1) * pageSize;
        return sorted.slice(start, start + pageSize);
    };


    ensureValidPage = (page, totalItems, pageSize) => {
        const tp = Math.max(1, Math.ceil((totalItems || 0) / (pageSize || 10)));
        return Math.min(tp, Math.max(1, page));
    };


    importVentas = async (file) => {


        const r = await importarVentasExcel(file);

        if (r.code === 0) {
            toast.success(r.message || "Ventas importadas.");
            this.fetchVentas(this.state.fecha);
            this.setState({ vermodalImpor: false });
        } else {
            toast.info(`${r.code} - ${r.message}`);
        }
    };

    importVentasSantnder = async (file) => {


        const r = await importSantanderExcel(file);

        if (r.code === 0) {
            toast.success("Ventas importadas correctamente.");
            this.fetchVentas(this.state.fecha);
            this.setState({ vermodalImpor: false });
        } else {
            toast.info(`${r.code} - ${r.message}`);
        }
    };



    // ===== icono PDF  =====
    PdfIcon = ({ title = "PDF" }) => (
        <svg className="v-pdf" viewBox="0 0 24 24" aria-label={title} role="img">
            <path d="M6 2h9l5 5v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8 1v5h5" />
            <path d="M7.5 15.5h2.2c.9 0 1.5-.6 1.5-1.5s-.6-1.5-1.5-1.5H7.5v6m0-3h2.1" />
            <path d="M12.8 18.5v-6h1.9c1.7 0 2.8 1.2 2.8 3s-1.1 3-2.8 3h-1.9z" />
            <path d="M19.2 12.5h2.8m-2.8 3h2.4m-2.4 3h2.1" />
        </svg>
    );

    render() {
        const { loading, fecha, ventas, page, pageSize, vermodalImpor } = this.state;
        const items = this.getPageItems();
        const totalPages = this.totalPages();

        return (



            <div className="v-page">

                <Navbar />



                {(loading == true) ? (
                    <SpinnerModal tipo="full" show={loading} />
                ) : null}

                <ImportVentasModal
                    show={vermodalImpor}
                    banderaSubir={this.state.banderaSubir}
                    toggle={() => this.setState({ vermodalImpor: false })}
                    loading={loading}
                    onImport={this.importVentas}
                    onImportSantander={this.importVentasSantnder}
                />



                <div className="v-shell">
                    {/* Header */}
                    <div className="v-top">
                        <h1 className="v-title">Ventas</h1>

                        <div className="v-actions">
                            <div className="v-date">
                                <span className="v-cal">📅</span>
                                <input type="date" value={fecha} onChange={this.onChangeFecha} />
                            </div>

                            <button className="v-btn" onClick={this.onImportar.bind(this, "normal")} disabled={loading}>
                                IMPORTAR VENTAS
                            </button>

                            <button className="v-btn" onClick={this.onImportar.bind(this, "santander")} disabled={loading}>
                                IMPORTAR Movimintos
                            </button>

                        </div>
                    </div>

                    {/* Tabla */}
                    <div className="vard">
                        <div className="v-card">
                            <div className="v-tableWrap">
                                <table className="v-table">
                                    <thead>
                                        <tr>
                                            <th className="v-thSort" onClick={() => this.onSort("ticket")}>Ticket</th>
                                            <th className="v-thSort" onClick={() => this.onSort("locacion")}>Locación</th>
                                            <th className="v-thSort" onClick={() => this.onSort("metodoPago")}>Método de Pago</th>
                                            <th className="v-thSort" onClick={() => this.onSort("subtotal")}>Detalles</th>
                                            <th className="v-thSort" onClick={() => this.onSort("total")}>Total</th>
                                            <th className="v-thSort" onClick={() => this.onSort("propina")}>Propina</th>
                                            <th className="v-thSort" onClick={() => this.onSort("fecha")}>Fecha</th>
                                            <th className="v-thSort" onClick={() => this.onSort("numeroProductos")}>Número de Productos</th>
                                            <th className="v-thSort" onClick={() => this.onSort("estatus")}>Estatus</th>
                                            <th>Factura</th>
                                        </tr>
                                    </thead>



                                    <tbody>
                                        {items.length === 0 ? (
                                            <tr>
                                                <td colSpan="10" className="v-empty">
                                                    No hay registros disponibles
                                                </td>
                                            </tr>
                                        ) : (
                                            items.map((v, idx) => (
                                                <tr key={`${v._key}-${(page - 1) * pageSize + idx}`}>
                                                    <td className="v-mono">{v.ticket}</td>
                                                    <td>{v.locacion}</td>
                                                    <td>{v.metodoPago}</td>
                                                    <td className="v-details" style={{ textAlign: "right", whiteSpace: "pre-line" }}>
                                                        {`Subtotal: ${this.currencyMX(v.detalles?.subtotal)}\nIVA: ${this.currencyMX(v.detalles?.iva)}`}
                                                    </td>
                                                    <td className="v-num">{this.currencyMX(v.total)}</td>
                                                    <td className="v-num">{this.currencyMX(v.propina)}</td>
                                                    <td>{v.fecha}</td>
                                                    <td className="v-num">{v.numeroProductos}</td>
                                                    <td>
                                                        <span
                                                            className={`v-badge ${String(v.estatus).toLowerCase() === "activo" ? "ok" : "warn"
                                                                }`}
                                                        >
                                                            {v.estatus}
                                                        </span>
                                                    </td>
                                                    <td className="v-pdfCol">
                                                        {v.ticketPdfUrl ? (
                                                            <a
                                                                className="v-pdfLink"
                                                                href={v.ticketPdfUrl}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                title="Ticket PDF"
                                                            >
                                                                <this.PdfIcon title="Ticket PDF" />
                                                            </a>
                                                        ) : (
                                                            <span className="v-pdfDisabled">—</span>
                                                        )}

                                                        {v.facturaPdfUrl ? (
                                                            <a
                                                                className="v-pdfLink"
                                                                href={v.facturaPdfUrl}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                title="Factura PDF"
                                                            >
                                                                <this.PdfIcon title="Factura PDF" />
                                                            </a>
                                                        ) : (
                                                            <span className="v-pdfDisabled">—</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Footer: paginación + contador */}
                            <div className="v-footer">
                                <div className="v-pagination">
                                    <button onClick={() => this.setPage(page - 1)} disabled={page <= 1 || loading}>
                                        ‹
                                    </button>

                                    <span className="v-pageInfo">
                                        {page} / {totalPages}
                                    </span>

                                    <button onClick={() => this.setPage(page + 1)} disabled={page >= totalPages || loading}>
                                        ›
                                    </button>
                                </div>

                                <div className="v-pageSize">
                                    <span>Mostrar:</span>
                                    <select value={pageSize} onChange={this.onChangePageSize}>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
